import { useTranslation } from 'react-i18next';
import { Spinner } from 'react-bootstrap';
import { CheckIcon } from '../../../../../assets/icons/CheckIcon';
import { ScheduleToolbarButton } from './ScheduleToolbarButton';
import { SchedulePublishStatusChip } from './SchedulePublishStatusChip';
import { useScheduleSavePublish } from './useScheduleSavePublish';

export function ScheduleSavePublishActions() {
  const { t } = useTranslation();
  const prefix = 'creativeDetail-';
  const {
    publishStatus,
    chipLabel,
    chipTimeLabel,
    actionsDisabled,
    updatingSchedule,
    publishingSchedule,
    saveDraftSchedule,
    publishSchedule,
  } = useScheduleSavePublish();

  return (
    <div className="schedule-toolbar__save-publish d-flex align-items-center gap-2 flex-shrink-0">
      <SchedulePublishStatusChip
        variant={publishStatus.variant}
        label={chipLabel}
        timeLabel={chipTimeLabel}
      />
      <ScheduleToolbarButton
        disabled={actionsDisabled}
        variant="outline-secondary"
        aria-label={t(prefix + 'scheduleSaveDraft')}
        title={t(prefix + 'scheduleSaveDraft')}
        onClick={saveDraftSchedule}
        icon={
          updatingSchedule ? (
            <Spinner size="sm" animation="border" aria-hidden className="schedule-toolbar__btn-icon" />
          ) : (
            <CheckIcon />
          )
        }
        labelClassName="d-none d-xl-inline small"
      >
        {t(prefix + 'scheduleSaveDraft')}
      </ScheduleToolbarButton>
      <ScheduleToolbarButton
        disabled={actionsDisabled}
        variant="primary"
        aria-label={t(prefix + 'schedulePublish')}
        title={t(prefix + 'schedulePublish')}
        onClick={publishSchedule}
        icon={
          publishingSchedule ? (
            <Spinner size="sm" animation="border" aria-hidden className="schedule-toolbar__btn-icon" />
          ) : (
            <CheckIcon />
          )
        }
        labelClassName="d-none d-xl-inline small"
      >
        {t(prefix + 'schedulePublish')}
      </ScheduleToolbarButton>
    </div>
  );
}
